import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './ToggleSwitchPanel.module.scss';

const ToggleSwitchPanel = ({ children, lightOnDark }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="ToggleSwitchPanel"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
        [CN.lightOnDark]: lightOnDark, // will be in default color on dark mode and in light color on light mode
      })}
    >
      {children}
    </div>
  );
};

export default ToggleSwitchPanel;
